import { MediaType } from '../../../data/compat/tvpil';
import { KalturaAssetIdentifier } from '../../composed';
import { createOnDemandResponseProfile, createPager, createSearchAssetFilter } from '../../factories';
import { phoenixConfig } from '../../network';
import { fetchAssetList } from '../../services';

export async function fetchEntitledChannels() {
  const { objects } = await fetchAssetList<KalturaAssetIdentifier>({
    filter: createSearchAssetFilter({
      kSql: `(and asset_type='${
        phoenixConfig.assetsMediaTypes[MediaType.Linear]
      }' (or entitled_assets='entitledSubscriptions' entitled_assets='free') )`,
    }),
    responseProfile: createOnDemandResponseProfile({
      retrievedProperties: 'id, error',
    }),
    pager: createPager({
      pageIndex: 1,
      pageSize: 500,
    }),
  });

  return new Set<number>(objects.map((e) => e.id));
}
